module.exports = require("@wordpress/i18n");